import { UseAssetClasses } from "@app/features/assets/useAssetClasses";
import { useEffect, useMemo, useState } from "react";

export const useAssetClassSelector = ({
  assetClasses,
  defAssetClassId,
}: {
  assetClasses: UseAssetClasses;
  defAssetClassId?: string;
}) => {
  const [assetClassId, setAssetClassId] = useState<string | undefined>(
    defAssetClassId,
  );

  useEffect(() => {
    if (
      !assetClasses.isLoading &&
      !assetClasses.items.some((i) => i.level4Id === assetClassId)
    ) {
      setAssetClassId(assetClasses.items.at(0)?.level4Id);
    }
  }, [assetClassId, assetClasses.items, assetClasses.isLoading]);

  return useMemo(() => {
    const valueField = "level4Id" as const;
    return {
      isLoading: assetClasses.isLoading,
      selectedItem: assetClasses.items.find((i) => i.level4Id === assetClassId),

      valueField,
      items: assetClasses.items,
      value: assetClassId,
      onChange: setAssetClassId,
    };
  }, [assetClassId, assetClasses.isLoading, assetClasses.items]);
};
